export default function SocialMediaIcon(props) {
    return <a href={props.data.link} type="social_media" rel="noopener noreferrer" target="_blank">
        <img className="social_media_icon" src={props.data.icon} alt={props.data.name} />
    </a>

}